import 'select2';
import WOW from 'wow.js'
import './csr_game';

// Some JavaScript Here
$(document).ready(function(){

  //index sidebar's dropdown animation
  $('.drop').click(function(){
    $(this).siblings('.dropdown-menu').slideToggle();
  });

  //static sidebar's dropdown animation
  $('.static-drop').click(function(){
    $('.static-dropdown-menu').slideToggle();
  });
  $('.left-nav-item > a').click(function(){
    event.preventDefault();
    $(this).parent().siblings().find('ul').slideUp();
    $(this).parent().find('ul').slideToggle();
    $(this).parent().addClass('open').siblings().removeClass('open');
  });

  //scroll to top animation
  $('.back-to-top').click(function(){
    $("html,body").animate({scrollTop: 0}, 1000);
  });

  //brand page tabpanel
  $('.nav-tabs li').click(function(){
    event.preventDefault();
    $(this).addClass('active').siblings().removeClass('active');
  });
  $('.content:first').show();
  $('.nav-tabs li:first').addClass('active');

  $('.tab-news').click(function(){
    event.preventDefault();
    $('.content-1').fadeIn(500).siblings().hide();
  });
  $('.tab-scuccess').click(function(){
    event.preventDefault();
    $('.content-2').fadeIn(500).siblings().hide();
  });
  $('.tab-technical').click(function(){
    event.preventDefault();
    $('.content-3').fadeIn(500).siblings().hide();
  });
  $('.tab-product').click(function(){
    event.preventDefault();
    $('.content-4').fadeIn(500).siblings().hide();
  });
  $('.tab-class').click(function(){
    event.preventDefault();
    $('.content-5').fadeIn(500).siblings().hide();
  });
  $('.tab-class').click(function(){
    event.preventDefault();
    $('.content-6').fadeIn(500).siblings().hide();
  });

  //brand static panel
  $('.panel-group > li > a').click(function(){
    event.preventDefault();
    // $(this).toggleClass('active');
    $(this).parent().siblings().find('ul').slideUp();
    $(this).parent().find('ul').slideToggle();
  });

  //wow.js animation plugin
  new WOW().init();

  //lightbox
  $('#open-modal').click(function(){
    $('#myModal').show();
  });
  $('#closeModal').click(function(){
    $('#myModal').css('display','none');
  });

  $('#sustainable_cancel').click(function(){
    $("#sustainable_popup").addClass('hide');
  });

  // accordion
  var activeAccordion = $('.accordion-item .accordion-main');
  $(activeAccordion).click(function(){
    $(this).toggleClass('active').siblings('.accordion-content').slideToggle(200);
    $(this).parent('.accordion-item').siblings('.accordion-item').find('.accordion-content').slideUp(200).siblings('.accordion-main').removeClass('active');
  });

  // index popup
  if (Cookies.get('popupLoad') === undefined) {
    $('#index_popup').find('.confirm').on('click', function() {
      $("#index_popup").addClass('close');
      Cookies.set('popupLoad', 'true');
    });
  } else {
    $('#index_popup').remove();
  }

  // 展開更多
  $('.show-more-btn').click(function(){
    $(this).parent('.hide-container').addClass('is-show');
  });

  // select 2
  const productSelect = document.getElementById('productSelect');
  if (productSelect) {
    $('#productSelect').select2({
      placeholder: "<%= t('select2.placeholder') %>",
      allowClear: true,
      minimumResultsForSearch: 0,
      dropdownCssClass: 'custom-product-select2-dropdown',
      // 客製化比對，從字首比對，讓下拉選單重新排序
      matcher: function(params, data) {
        // 使用者沒打字，就直接顯示所有選項
        if ($.trim(params.term) === '') {
          return data;
        }

        const term = params.term.toLowerCase();
        const text = (data.text || '').toLowerCase();

        // 完全沒有符合的話就忽略這選項
        if (text.indexOf(term) === -1) {
          return null;
        }

        // 判斷這個選項文字是不是「從 term 開頭」
        const matchStart = text.startsWith(term);
        // 開頭符合的排序權重是 1
        const sortPriority = matchStart ? 1 : 2;

        data.sortPriority = sortPriority;
        return data;
      },
      sorter: function(results) {
        // 開頭符合排在前面，中間才符合排後面
        return results.sort(function(a, b) {
          return (a.sortPriority || 2) - (b.sortPriority || 2);
        });
      }
    });
  }
  $('.js-example-basic-multiple').select2();

  $('#productSelect').on('change', function() {
    var selectedBrand = $(this).val();
    if (selectedBrand) {
      $('#productList .item').hide();
      $('#productList .item[data-brand="' + selectedBrand + '"]').show();
    } else {
      $('#productList .item').show();
    }
  });
  $('.select2-brand-solution-mobile').select2({
    placeholder: $('.select2-brand-solution-mobile').data('placeholder'),
    dropdownCssClass: 'custom-solution-select2-dropdown',
  });

  $('.select2-brand-solution-mobile').on('select2:select select2:unselect', function () {
    const $form = $(this).closest('form');
    const currentAction = $form.attr('action');
    if (!currentAction.includes('#brandSearchGroup')) {
      $form.attr('action', currentAction + '#brandSearchGroup');
    }
    setTimeout(function () {
      $form.trigger('submit');
    }, 100);
  });
  if (window.location.hash === '#brandSearchGroup') {
    const el = document.getElementById('brandSearchGroup');
    if (el) {
      const offset = 70;
      const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }
  let lastWidth = window.innerWidth;
  $(window).on('resize', function () {
    const nowWidth = window.innerWidth;
    if (window.location.pathname === '/brands' && lastWidth <= 991 && nowWidth > 991) {
      const cleanPath = window.location.pathname;
      window.location.href = cleanPath; // 移除 ?q=... 等參數
    }
    lastWidth = nowWidth;
  });


  // micro365
  $('.tab[data-micro]').on('click', function () {
    var ID = $(this).data('micro');
    $(this).addClass('active').siblings().removeClass('active');
    $("#" + ID).addClass('active').siblings().removeClass('active');
  });
})
$(document).on('select2:open', e => {
  const id = e.target.id;
  const target = document.querySelector(`[aria-controls=select2-${id}-results]`);
  target.focus();
});
